import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

const CropPreviewComponent = (props: { filePath: string; alt?: string }) => {
    const [showDetail, setShowDetail] = useState(false);

    return (
        <>
            <img
                onClick={() => setShowDetail(!showDetail)}
                className={"img-thumbnail preview-image"}
                src={props.filePath}
                alt={props.alt || "Titulný obrázok"}
            />

            <Modal show={showDetail} onHide={() => { setShowDetail(false) }} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Náhľad obrázka</Modal.Title>
                </Modal.Header>
                <Modal.Body className={"text-center"}>
                    <img className="img-fluid st-crop-preview-img"
                         src={props.filePath}
                         alt={props.alt || "Titulný obrázok"}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        setShowDetail(false);
                    }}>
                        Zavrieť
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CropPreviewComponent;
